import script from "./HighlightToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightToolbar.vue?vue&type=script&setup=true&lang=js"

import "./HighlightToolbar.vue?vue&type=style&index=0&id=bc1f6eb4&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc1f6eb4"]])

export default __exports__